import { render } from "./LocatairesPage.vue?vue&type=template&id=dfe74a78"
import script from "./LocatairesPage.vue?vue&type=script&lang=js"
export * from "./LocatairesPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__